<template lang="pug">
.answers.answers-date
	bunt-input.answer(type="date", v-model="value")
	bunt-button.btn-next(@click="next", name="date") Weiter
</template>
<script>
import moment from 'moment'
export default {
	components: {},
	props: {
		question: Object
	},
	data () {
		return {
			value: ''
		}
	},
	methods: {
		next () {
			this.$store.dispatch('anwserCurrentQuestion', moment(this.value))
		}
	}
}
</script>
<style lang="stylus">
@import '~settings'
.questionnaire-form .step .answers-date
	display: flex
	flex-direction: column
	.answer
		margin: 16px
</style>
